var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.28,
    height: 34.218,
    viewBox: "0 0 27.28 34.218",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cancelled",
    transform: "translate(-3.5 -1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M9.5,11l8.672,8.672",
    transform: "translate(3.304 5.875)",
    fill: "none",
    stroke: "#878a99",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M18.172,11,9.5,19.672",
    transform: "translate(3.304 5.875)",
    fill: "none",
    stroke: "#878a99",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M27.248,9.64a7.381,7.381,0,0,1,1.768,2.141,7.381,7.381,0,0,1,.264,2.764V27.28c0,3.27,0,4.905-1.016,5.921s-2.651,1.016-5.921,1.016H11.937c-3.27,0-4.905,0-5.921-1.016S5,30.551,5,27.28V9.937c0-3.27,0-4.905,1.016-5.921S8.667,3,11.937,3h5.8a7.379,7.379,0,0,1,2.764.264,7.379,7.379,0,0,1,2.141,1.768Z",
    fill: "none",
    stroke: "#878a99",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelled);
export default __webpack_public_path__ + "static/media/Cancelled.e4a12093195ea640b5d751e7f0065a0c.svg";
export { ForwardRef as ReactComponent };